import { Inject, Injectable } from '@angular/core';
import { LDClientSDK } from '@app/shared/services/ldclientsdk.token';
import { LDClient } from 'launchdarkly-js-client-sdk';

/**
 * Org Managed Content Service
 * @description Service used to help determine org-managed content
 */
@Injectable({ providedIn: 'root' })
export class OrgManagedContentService {
  constructor(@Inject(LDClientSDK) public ldClientSDK: LDClient) {}

  public orgManagedNotificationFlag = this.ldClientSDK.variation(
    'pathway-visibility-enhancements-20220419',
    false
  );

  /**
   * Checks if contents are org-managed
   */
  public isContentsOrgManaged(items: any): boolean {
    if (!this.orgManagedNotificationFlag) {
      return false;
    }
    return (
      items.filter((item) => {
        return item?.organizationId;
      }).length > 0
    );
  }
}
